<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="registerSuccessModal">
        <div class="modal-dialog" role="document">
            <div class="box k6-modal-container">
                <div>
                    <img src="../../assets/register_success.svg" style="height: 200px; width: 350px" />
                </div>
                <div class="text-center">
                    <h2 style="font-weight: bold;">{{ $t("pages.register.emailSent") }}</h2>
                    <p>{{ $t("pages.register.emailSentSuccess") }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>
.box {
    padding: 20px;
}
</style>



// WEBPACK FOOTER //
// RegisterSuccessModal.vue?07c398de